import { alpha, styled } from '@mui/material/styles';

import { Typography } from '../../components/atoms/Typography';

export type LoginErrorSeverity = 'info' | 'warning' | 'error';

export const TitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const BodyTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

// The v4 tokens only exist on the app's lightTheme — fall back to the standard
// palette so these components don't crash under MUI's default theme (e.g. in
// consumer tests that render without the app ThemeProvider).
export const PageWrapper = styled('main')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.v4?.background ?? theme.palette.background.default,
}));

export const ErrorCard = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  width: '100%',
  maxWidth: '440px',
  padding: theme.spacing(5, 4),
  backgroundColor: theme.palette.v4?.surface ?? theme.palette.background.paper,
  border: `1px solid ${theme.palette.v4?.border ?? theme.palette.divider}`,
  borderRadius: theme.spacing(1.5),
  boxShadow: theme.shadows[2],
  gap: theme.spacing(1.5),
}));

export const LogoImage = styled('img')(({ theme }) => ({
  height: theme.spacing(5.5),
}));

export const IconCircle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'severity',
})<{ severity: LoginErrorSeverity }>(({ theme, severity }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  borderRadius: '50%',
  backgroundColor: alpha(theme.palette[severity].main, 0.12),
  color: theme.palette[severity].main,
  margin: theme.spacing(2, 0, 0.5),
}));

export const ActionRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(2.5),
}));
